import { AavoContextMenuContext } from "src/components/common/contextMenu/AavoContextMenu.tsx";
import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import {
	AavoContextMenuItem,
	AavoContextMenuItemProps,
} from "src/components/common/contextMenu/AavoContextMenuItem.tsx";
import { MaybeAsyncFunction } from "src/types/functions";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export interface AsyncButtonContextMenuItemProps
	extends Omit<AavoContextMenuItemProps, "onClick" | "disabled">,
		Pick<AsyncButtonProps, "label" | "icon" | "iconEl" | "onClick" | "tooltip" | "disabled"> {
	label: string;
	icon?: IconDefinition;
	iconEl?: React.ReactNode;
	onClick: MaybeAsyncFunction<void, any>;
}

export const AsyncButtonContextMenuItem = ({
	label,
	icon,
	iconEl,
	onClick,
	tooltip,
	disabled,
	...other
}: AsyncButtonContextMenuItemProps) => {
	const { closeContextMenu } = useContextOrThrow(AavoContextMenuContext);

	return (
		<AavoContextMenuItem {...other}>
			<AsyncButton
				onClick={async () => {
					await onClick();
					closeContextMenu();
				}}
				icon={icon}
				iconEl={iconEl}
				color={"inherit"}
				label={label}
				tooltip={tooltip}
				disabled={disabled}
			/>
		</AavoContextMenuItem>
	);
};
